<template>
     <main>
        <pop-request-mtm :show="Mtm" @accept="joinmtm" @close="mtmpopClose" title="1:1 채팅 신청"/>
        <div class="chatroomLists">
            <!-- <component :is="activePage"></component> -->
            <section class="header">
                <div class="title">
                    <span>채팅 대기실</span>
                   멘트
                </div>
                <div class="addRoom" @click="createchatroom">
                    채팅방 개설하기
                </div>
            </section>
            <section class="body">
                <div class="roomLists">
                    <chat-room-list @join-room="joinRoom"/>
                </div>
                <div class="aside">
                    <div class="myInfo">
                        <div class=top>
                            <h3>내정보</h3>
                        </div>
                        <div class="cont">
                            <user-name-tag :user="currentUser" :displaymytalk="true" :displayProfileImage="true"/>
                        </div>
                    </div>
                    <div class=list-wrapper>
                        <ul>
                            <li class="item active" id="user-list">
                                <a href="javascript:void(0)" class="btn" @click="arrowtg('user-list')">
                                    <div class="top" >
                                        <div class="title">대기실 목록</div>
                                        <div class="cnt"><span>{{users.length}}</span></div>
                                        <div class="arrow">
                                            <font-awesome-icon icon="angle-up"  v-if="arrowtoggle"/>
                                            <font-awesome-icon icon="angle-down"  v-else/>
                                        </div>
                                    </div>
                                </a>
                                <div class="subMenu">
                                    <div class="user-list">                                       
                                         <template v-for="(user, index) in users" :key="index">
                                            <user-name-tag
                                            :user="user"
                                            :displaymytalk="false"
                                            :displayProfileImage="true"
                                            />
                                        </template>
                                    </div>
                                </div>
                            </li>
                            <li class="item" id="friend-list" >
                                <a href="javascript:void(0)" class="btn" @click="arrowtg('friend-list')">
                                     <div class="top" >
                                        <div class="title">친구 목록</div>
                                        <div class="arrow">
                                            <font-awesome-icon icon="angle-up"  v-if="!arrowtoggle"/>
                                            <font-awesome-icon icon="angle-down"   v-else/>
                                        </div>
                                    </div>
                                </a>
                                <div class="subMenu">
                                    <div class="user-list">
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
            </section>
            <section class="footer">
                <copyright/>
            </section>
        </div>
    </main>
</template>

<script>
//import io from 'socket.io-client';
import ChatRoomList from '@/components/chat/ChatRoomList';
import PopRequestMtm from "@/components/ui/PopRequestMtm";
import { removeClass } from '@/utils/selector.js';
import { auth } from '@/components/mixins/auth.js';
import { socketio } from '@/components/mixins/socketio.js';
export default {
    data(){
        return{
            chatroomLists:{},
            isLoading: false,           
            // users:[],
            // currentUser:[],
            arrowtoggle:true,
            nowview:'userlist',
            //Mtm:false,
            mtmInfo:'',
            chat_roomId:'lobby'
        }
    },
     mixins:[
        auth,socketio
    ],
    components:{
        ChatRoomList,
        PopRequestMtm
    },
    // created(){
    //     this.$store.dispatch('tryLogin');
    // },
    mounted() {
        this.currentUser = this.$store.getters.currentUser;       
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isAuthenticated;
        },
        user() {
            return this.$store.getters.currentUser;
        },
    },
    methods:{
        async createchatroom(){
            if(!this.isLoggedIn)
            {
                alert('로그인이 필요 합니다.');
                //alert(this.$route.name);
                this.socket.disconnect();
                this.$router.push({ name: 'auth_login', params: { prevroute: 'chat_roomCreate' }})
            }else{
                //아이템 유무 판단
                const ckitem =  await this.ckItem('chat_makeroom','pop');
                if(!ckitem){
                    return;
                }
                this.socket.disconnect();
                this.$router.push('/chat/create');
            }
        },
        arrowtg(now){

            if(this.nowview !== now)
            {
                // alert(this.nowview);
                // alert(now);
                this.arrowtoggle = !this.arrowtoggle;
                this.nowview = now;
                removeClass('.item','active');
                let element = document.querySelector('#'+now);
                element.classList.add('active');
            }
        },
        joinRoom(){
            //로비 리스트에서 채팅방 참가 해서 로비 연결은 끊어준다.
            this.socket.disconnect();
        },
        
         listen(){
            this.socket.on('updateUsersList', (users)=>{
                this.users = users;
                console.log(this.users);
            });           
          
            
        },
        mtmpopClose(){
            //1:1채팅 거절
            this.socket.emit("MtmDeny", this.mtmInfo, function (callback) {
                alert(callback);
            });
            this.Mtm=false;
        },
        // joinmtm()
        // {
        //     //alert('1:1채팅 참여');
        //     this.socket.disconnect();
        //      //참여 하면서 1:1 채팅 신청자의 아이템 차감
        //     this.$store.dispatch('item/deductionItem',
        //           {user_id:this.mtmInfo.fromId, item_name:'chat_mtm'});//1:1채팅 신청자 아이템 차감
        //     this.$router.push({
        //         path: "mtm/"+this.mtmInfo.room
        //     });
        //     this.mtmpopClose();
        // },
        removeClass(selector, myClass)
        {
            // get all elements that match our selector
            let elements = document.querySelectorAll(selector);

            // remove class from all chosen elements
            for (var i=0; i<elements.length; i++) {
                elements[i].classList.remove(myClass);
            }
        }

    }
}
</script>

<style lang="scss" scoped>
main{
    background:#fff;
    font-family: gulim, dotum;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .header{
        line-height: 40px;
        background-color: #39302d;
        display: flex;
        font-size: 12px;
        color:#ffde00;
        font-weight: bold;
        justify-content: space-between;//꽉차가 화면 배분
        flex-wrap:wrap;//한줄에 가득차면 다음줄로
        .title{
            span{color:#fff;font-size: 12px;display: inline-block;padding-right: 10px;}
            padding-left: 10px;
        }
        .addRoom{
            padding-right:10px;
            cursor:pointer;
        }
    }
    .body{
        display: flex;
        justify-content: space-between;
        align-items:flex-start;
        height: calc(100vh - 60px);
        .roomLists{
            flex:1 1 auto;
            height:100%;
        }
        .aside{
            flex-basis:340px;
            border-left:1px solid #000;
            .cnt span{
                background:#ee1212;
                border-radius:6px;
                color:#fff;
                font-size:11px;
                padding:2px 5px 2px 5px;
            }
            .myInfo{
                .top{
                    background:#f3f3f3;
                    line-height:30px;
                    font-size:12px;
                    border-bottom:1px solid #ccc;
                    h3{
                        margin:0;
                        font-size:12px;
                        padding-left:10px
                    }
                }
                .user{
                    display:flex;
                    .profileImg{
                        width:30px;
                        height:30px;
                        padding:10px;
                        .img{
                            background-color:#000;
                            width:30px;
                            height:30px;
                        }
                    }
                    .userName{
                        font-weight:bold;
                        font-size:12px;
                        line-height:50px;
                        padding-left:20px;
                        flex:1 1 auto;
                    }
                    .myTalk{
                        font-size:11px;
                        color:#3e3e3e;
                        padding-right:10px;
                    }
                }
            }
            .list-wrapper{
                .item a{
                    text-decoration:none;
                    color: #ccc;
                }
                .item{
                    overflow: hidden;
                    .subMenu{
                        overflow: hidden;
                        transition: height 0.7s;
                        height: 0;
                    }
                    .top{
                        border-top:1px solid #000;
                        border-bottom:1px solid #eee;
                        line-height:20px;
                        display:flex;
                        .title{
                            font-weight:normal;
                            font-size:11px;
                            font-family: 돋움, dotum;
                            padding-left:10px;
                            padding-top:3px;
                            flex:1 1 auto
                        }
                        .cnt{
                            flex-basis: 15px;
                        }
                        .arrow{
                            flex-basis: 30px;
                            padding-left:5px;
                        }
                    }
                }
                .active{
                    a{color:#000;}
                    .subMenu{
                        max-height:calc(100vh - 191px);
                        height:calc(100vh - 191px);
                    }
                }
            }
        }
    }
    .footer{
       background-color: #39302d;
       font-size:10px;
       color: #777371;
       font-family: Arial,Helvetica,sans-serif;
       line-height:20px
    }
}
</style>


